import React, { useState, useRef, useEffect } from 'react';
import { useNavigate } from "react-router-dom";

import { ProfileIcon, BellIcon, MenuIcon } from '../../Constants/Icons';
import { orangeButton, newNavbarContainer, navbarButtonContainer, navbarMenuButton, menuNavbarContainer, menuNavbarX, newNavbarButton, menuNavbarButtonContainer, menuNavbarButton, navbarLogoContainer } from '../../Constants/Styles';
import { isUserSignedIn } from '../API/API_Handler';
const MainNav = ({ navbarColor }) => {
    const styles = {
        container: 'w-full h-[55px] xs:h-[75px] xl:h-[85px] flex items-center flex-row justify-between shadow-md bg-[#26051C] md:px-8 xl:px-12 transition-all duration-300',
        logoButton: 'w-48 mx-4 xs:w-60 xl:w-72 xs:mx-6',
        mobileMenuButton: 'block sm:hidden mx-4 xs:mx-6',
        mobileMenuContainer: 'fixed top-0 right-0 bg-charmPurple border border-gray-300 p-4 flex flex-col w-full h-full transition-transform duration-300',
        closeButton: 'text-white self-end text-lg xl:text-xl font-semibold py-2',
        menuButtonContainer: 'w-full flex items-center justify-center',
        menuButton: 'w-fit text-white text-lg xl:text-xl font-semibold py-2 hover:border-b-4 border-link',
        dropdownContainer: 'fixed top-0 right-0 bg-white border border-gray-300 p-4 flex flex-col w-[25rem] h-40 z-50',
        vendorInfo: 'font-bold',
        accountButtonContainer: 'mt-6 flex flex-row justify-start',
        accountButton: 'text-white text-lg xl:text-xl font-semibold px-4 xl:px-5 py-2 xl:py-3 bg-link hover:text-integrationRequestTextHover hover:bg-charmHover w-fit rounded-full mr-5',
        signOutButton: 'text-white text-lg xl:text-xl font-semibold px-4 xl:px-5 py-2 xl:py-3 bg-link hover:text-integrationRequestTextHover hover:bg-charmHover w-fit rounded-full',
        desktopMenuContainer: 'hidden sm:flex flex-row mx-4 xs:mx-6 gap-4 xs:gap-12 justify-between items-center',
        desktopMenuButton: 'w-fit text-white text-lg xl:text-xl font-semibold py-2 border-b-4 border-transparent hover:border-link transition-all duration-300',
        bellIcon: 'h-[20px] xs:h-[26px] transform hover:scale-125 transition-transform duration-100',
        profileIcon: 'h-[28px] xs:h-[36px] transform hover:scale-125 transition-transform duration-100'
    };

    const navigate = useNavigate();
    const dropdownRef = useRef(null);

    const [isSignedIn, setIsSignedIn] = useState(false);

    const handleLogin = () => {
        const loginUrl = 'https://accounts.charmtracker.com/oauth/v2/auth?client_id=1000.RB6DWOYZJ54A25SZPTB5D3P8DQP0SQ&redirect_uri=https://charmhealthhub.com/authenticating&scope=openid+email+charmhealth.user.addons.READ+profile&response_type=token';
        window.location.href = loginUrl;
    };

    const handleLogout = () => {
        sessionStorage.removeItem('accessToken');
        sessionStorage.removeItem('idToken');
        setIsSignedIn(false);
        navigate("/");
    }

    const handleLogo = () => {
        navigate("/");
    };

    const handleOrders = () => {
        navigate("/orders");
    };

    const handleMessages = () => {
        navigate("/messages");
    };


    const handleForVendors = () => {
        navigate("/vendors");
    }

    const handleExplore = () => {
        navigate("/explore/category/all");
    }

    useEffect(() => {
        const isLoggedIn = isUserSignedIn();
        setIsSignedIn(isLoggedIn);
    }, []);

    const [isVisible, setIsVisible] = useState(false);

    const toggleVisibility = () => {
        setIsVisible(!isVisible);
    };

    const handleClickOutside = (event) => {
        if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
            setIsVisible(false);
        }
    };

    useEffect(() => {
        if (isVisible) {
            document.addEventListener('mousedown', handleClickOutside);
        } else {
            document.removeEventListener('mousedown', handleClickOutside);
        }

        return () => {
            document.removeEventListener('mousedown', handleClickOutside);
        };
    }, [isVisible]);


    const [isMenuVisible, setIsMenuVisible] = useState(false);

    const toggleMenuVisibility = () => {
        setIsMenuVisible(!isMenuVisible);
    };

    

    return (
        <div className="w-full h-[60px] flex flex-row justify-between items-center px-basePx xs:px-xsPx 1.5xl:py-[18px] 1.5xl:px-[104px]" style={{ backgroundColor: navbarColor, transition: 'background-color 0.4s ease' }}>
            <button onClick={handleLogo} className="w-[248px] min-w-[248px] xl:w-[280px]">
                <img
                    src={'https://charmhealth-marketplace-assets.s3.amazonaws.com/Homepage/charmhealthhub_logo_wht_ylw.png'}
                    alt="Logo"
                    className="w-full"
                />
            </button>
            {
                isSignedIn ?
                    <div>
                        <button className="lg:hidden" onClick={toggleMenuVisibility}>
                            <MenuIcon />
                        </button>

                        {isMenuVisible && (
                            <div className="lg:hidden px-[32px] fixed top-0 right-0 bg-[#26051C] flex flex-col w-full h-screen" style={{ zIndex: 50 }}>
                                <button className="pr-[12px] pt-[12px]  text-white self-end  text-[20px] font-extrabold" onClick={toggleMenuVisibility}>
                                    X
                                </button>
                                <div className="mt-[20px] w-full flex flex-col items-center gap-[12px] ">
                                    <button className="h-fit w-fit text-white text-[18px] font-proximanova border-b-[2px] border-transparent hover:border-link transition-all duration-500" onClick={handleExplore}>
                                        Browse Listings
                                    </button>
                                    <button className="h-fit w-fit text-white text-[18px] font-proximanova border-b-[2px] border-transparent hover:border-link transition-all duration-500" onClick={handleMessages}>
                                        My Messages
                                    </button>
                                    <button className="h-fit w-fit text-white text-[18px] font-proximanova border-b-[2px] border-transparent hover:border-link transition-all duration-500" onClick={toggleVisibility}>
                                        My Profile
                                    </button>
                                </div>
                            </div>
                        )}

                        <div className="hidden lg:flex h-[60px] flex-row items-center gap-[56px] ">
                            <button className="h-full text-white text-[18px] font-proximanova border-b-[2px] border-transparent hover:border-link transition-all duration-500" onClick={handleExplore}>
                                Browse Listings
                            </button>

                            <button className="h-full text-white text-[18px] font-proximanova border-b-[2px] border-transparent hover:border-link transition-all duration-500" onClick={handleMessages}>
                                My Messages
                            </button>

                            <button onClick={toggleVisibility}>
                                <ProfileIcon />
                            </button>

                        </div>

                        {isVisible && (
                            <div ref={dropdownRef} className={styles.dropdownContainer}>
                                <div className={styles.vendorInfo}>
                                    {sessionStorage.getItem('first_name') || 'First Name'} {sessionStorage.getItem('last_name') || 'Last Name'}
                                </div>
                                <div>
                                    {sessionStorage.getItem('email') || 'Email not available'}
                                </div>
                                <div className={styles.accountButtonContainer}>
                                    <button
                                        onClick={() => window.open("https://accounts.charmtracker.com/signin?hide_signup=true&hide_secure=true&hide_gsignup=true&servicename=charmhealth&serviceurl=https%3A%2F%2Fehr2.charmtracker.com%2Fehr%2Fmain.do", "_blank")}
                                        className={styles.accountButton}
                                    >
                                        My EHR
                                    </button>
                                    <button className={styles.signOutButton} onClick={handleLogout}>Sign Out</button>
                                </div>
                            </div>
                        )}

                    </div>
                    :
                    <div>
                        <button className="lg:hidden" onClick={toggleMenuVisibility}>
                            <MenuIcon />
                        </button>

                        {isMenuVisible && (
                            <div className="lg:hidden px-[32px] fixed top-0 right-0 bg-[#26051C] flex flex-col w-full h-screen" style={{ zIndex: 50 }}>
                                <button className="pr-[12px] pt-[12px]  text-white self-end  text-[20px] font-extrabold" onClick={toggleMenuVisibility}>
                                    X
                                </button>

                                <div className="mt-[20px] w-full flex flex-col items-center gap-[12px] ">
                                    <button className="h-fit w-fit text-white text-[18px] font-proximanova border-b-[2px] border-transparent hover:border-link transition-all duration-500" onClick={handleExplore}>
                                        Browse Listings
                                    </button>

                                    <button className="h-fit w-fit text-white text-[18px] font-proximanova border-b-[2px] border-transparent hover:border-link transition-all duration-500" onClick={handleForVendors}>
                                        For Vendors
                                    </button>

                                    <button className="h-fit w-fit text-white text-[18px] font-proximanova border-b-[2px] border-transparent hover:border-link transition-all duration-500" onClick={handleLogin}>
                                        Login
                                    </button>
                                </div>
                            </div>
                        )}

                        <div className="hidden lg:flex h-[60px] flex-row items-center gap-[56px] ">
                            <button className="h-full text-white text-[18px] font-proximanova border-b-[2px] border-transparent hover:border-link transition-all duration-500" onClick={handleExplore}>
                                Browse Listings
                            </button>

                            <button className="h-full text-white text-[18px] font-proximanova border-b-[2px] border-transparent hover:border-link transition-all duration-500" onClick={handleForVendors}>
                                For Vendors
                            </button>

                            <button className="text-white text-[18px] font-proximanova rounded-full py-[2px] px-[50px]  border-[2px] border-white" onClick={handleLogin}>
                                Login
                            </button>
                        </div>
                    </div>
            }
        </div >
    );
}

export default MainNav;